export default "__VITE_ASSET__2jrFuORF__"